export function isModuleLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;

  // Thrown by Vite's own preload helper rather than by the browser, so it arrives as a
  // plain `Error` and never passes the `TypeError` gate below.
  if (error.message.startsWith("Unable to preload CSS for")) return true;

  if (!(error instanceof TypeError)) return false;
  return (
    error.message === "Importing a module script failed." || // Safari
    error.message.startsWith("Failed to fetch dynamically imported module:") || // Chrome/Opera/Blink
    error.message.startsWith("error loading dynamically imported module") // Firefox/Gecko
  );
}
